export default __webpack_public_path__ + "static/media/10.c4a51d2a.jpg";